<template>
  <div>
    <bclose-popup ref="bclosePopup1" class="down_box_popup" @close="handleClose">
      <div class="title">APP专属活动，等你参加！</div>
      <div class="downImg">
        <img src="@/assets/image/icon/39box.png" mode="" />
      </div>
      <div class="down_tip">更多游戏礼包、更流畅体验，尽在官方App</div>
      <div class="down_box" @click="downApp">
        <div class="downbox-down">
          <div class="downBtn">立即下载</div>
        </div>
      </div>
    </bclose-popup>
  </div>
</template>

<script>
import { callApp } from "@/utils/down.js"
export default {
  name: 'VueNew39DownPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {
    open() {
      this.$refs.bclosePopup1.open()
    },
    handleClose() {
      this.$store.commit('popup/setPagePopupData', {})
    },
    //立即下载
    async downApp() {
      const data = location.href
      await callApp(data, 2000)
    }
  },

  watch: {
    show(val) {
      if (val) {
        this.open()
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.down_box_popup {
  .title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    line-height: 19px;
  }

  .downImg {
    margin-top: 20px;
    margin-bottom: 23px;

    img {
      width: 80px;
      height: 80px;
      border-radius: 0px 0px 0px 0px;
    }
  }

  .down_tip {
    margin-bottom: 27px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 19px;
    text-align: center;
  }

  .downbox-down {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 230px;
    height: 40px;
    background: linear-gradient(271deg, #1d1d1d 0%, #5b4e3f 100%);
    border-radius: 25px 25px 25px 25px;
    cursor: pointer;

    .downBtn {
      padding-top: 9px;
      padding-bottom: 11px;
      color: #fbd37d;
      font-size: 14px;
    }
  }
}
</style>